import {interpolateLab, piecewise} from "d3";
import type {Theme} from "@mui/material";
import {darken} from "@mui/material";

const clamp = (share: number) => Math.min(1, Math.max(0, share));

// Lab through the light brand blue keeps the in-between shades blue instead of greyish
const scale = (theme: Theme) => piecewise(interpolateLab, ['#FFFFFF', theme.palette.mithraBlue[300], theme.palette.mithraBlue[500]]);

/** White for the lowest spend, Mithra blue for the highest */
export function spendColor(theme: Theme, share: number): string {
    return scale(theme)(clamp(share));
}

/** Slightly darker blue outline that matches the fill */
export function spendBorderColor(theme: Theme, share: number): string {
    return darken(spendColor(theme, Math.max(0.25, clamp(share))), 0.12);
}

/** Switch to white text once the background is dark enough */
export function spendTextColor(theme: Theme, share: number): string {
    return share > 0.65 ? theme.palette.common.white : theme.palette.mithraBlue[800];
}
